export const NAME = 'errorReport';

export const errorsToReport = [500, 503, 404, 408];
